import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=57562b23"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"
import style0 from "./Slider.vue?vue&type=style&index=0&id=57562b23&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57562b23')) {
      api.createRecord('57562b23', component.options)
    } else {
      api.reload('57562b23', component.options)
    }
    module.hot.accept("./Slider.vue?vue&type=template&id=57562b23", function () {
      api.rerender('57562b23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/preview/Slider.vue"
export default component.exports